export default __webpack_public_path__ + "client04.jpg";